import { CorbanModalityPermission, CreditTypeCorban } from "@/models/corban.model";
import { axiosInstance } from "./axiosInstance";

export const getCreditTypesByCorbanId = async (
  corbanId: number
): Promise<CorbanModalityPermission[]> => {
  try {
    const response = await axiosInstance.get(
      `/api/credit-type/corban/${corbanId}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter produtos por Corban ID:", error);
    throw error;
  }
};

export const createCreditType = async (
  creditTypeData: Partial<any>
): Promise<any> => {
  try {
    const response = await axiosInstance.post<any>(
      `/api/credit-type`,
      creditTypeData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao criar produto:", error);
    throw error;
  }
};

export const updateCreditType = async (
  creditTypeData: Partial<CreditTypeCorban>
): Promise<CreditTypeCorban> => {
  try {
    const response = await axiosInstance.put<CreditTypeCorban>(
      `/api/credit-type`,
      creditTypeData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar produto:", error);
    throw error;
  }
}